<div class="row justify-content-center">
    <div class="col col-sm-8 col-md-7 col-lg-5 col-xl-6 col-xxl-4">
        <div class="d-flex justify-content-center mb-4">
            <img class="bg-image" src="../../../assets/img/png/NexionSolutionslogo-Login.png" />
        </div>
        <form [formGroup]="activateForm" autocomplete="off">
            <div class="card">
                <div class="card-body p-3">
                    <h4 class="card-title text-center">{{ cardTitle }}</h4>
                    <p class="text-center">{{ subTitle }}</p>
                    <div class="md-form mb-2" *ngIf="!isForgotPassword">
                        <label for="email" class="form-label">Email</label>
                        <div class="input-group flex-nowrap me-3"
                            [class.is-invalid]="activateForm.controls['email'].dirty && activateForm.get('email')?.invalid">
                            <div class="input-group input-group-lg">
                                <input type="email" class="form-control px-1" id="email"
                                    formControlName="email" readonly />
                            </div>
                        </div>
                    </div>

                    <div class="md-form mb-2">
                        <label for="newPassword" class="form-label">Password</label>
                        <div class="input-group flex-nowrap me-3"
                            [class.is-invalid]="activateForm.controls['newPassword'].dirty && activateForm.get('newPassword')?.invalid">
                            <div class="input-group input-group-lg">
                                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control px-1"
                                    id="newPassword" formControlName="newPassword" />
                                <span (click)="showNewPassword = !showNewPassword"
                                    class="input-group-text px-1 cursor-pointer">
                                    <i-bs class="mx-2" [name]="showNewPassword ? 'eye' : 'eye-slash'"></i-bs>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="md-form mb-2">
                        <label for="confirmNewPassword" class="form-label">Confirm Password</label>
                        <div class="input-group flex-nowrap me-3"
                            [class.is-invalid]="activateForm.controls['confirmNewPassword'].dirty && activateForm.get('confirmNewPassword')?.invalid">
                            <div class="input-group input-group-lg">
                                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control px-1"
                                    id="confirmNewPassword" formControlName="confirmNewPassword" />
                                <span (click)="showConfirmPassword = !showConfirmPassword"
                                    class="input-group-text px-1 cursor-pointer">
                                    <i-bs class="mx-2" [name]="showConfirmPassword ? 'eye' : 'eye-slash'"></i-bs>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="md-form">
                        <span class="fs-1">Password must include</span>
                        <ul class="fa-ul text-left">
                            <li class="mb-1 fs-1">
                                <span class="fa-li">
                                    <i-bs [name]="ruleIcon(hasMinLength)" [class]="ruleClass(hasMinLength)"></i-bs>
                                </span>
                                <small [class]="ruleClass(hasMinLength)">At least 8 characters</small>
                            </li>
                            <li class="mb-1 fs-1">
                                <span class="fa-li">
                                    <i-bs [name]="ruleIcon(hasUppercase)" [class]="ruleClass(hasUppercase)"></i-bs>
                                </span>
                                <small [class]="ruleClass(hasUppercase)">At least one Uppercase</small>
                            </li>
                            <li class="mb-1 fs-1">
                                <span class="fa-li">
                                    <i-bs [name]="ruleIcon(hasSpecialAndNumber)" [class]="ruleClass(hasSpecialAndNumber)"></i-bs>
                                </span>
                                <small [class]="ruleClass(hasSpecialAndNumber)">At least one special character i.e #@! and a number</small>
                            </li>
                            <li class="mb-1 fs-1">
                                <span class="fa-li">
                                    <i-bs [name]="ruleIcon(passwordsMatch)" [class]="ruleClass(passwordsMatch)"></i-bs>
                                </span>
                                <small [class]="ruleClass(passwordsMatch)">New Password and Confirm Password matched</small>
                            </li>
                        </ul>
                    </div>

                    <button type="submit" class="btn btn-lg btn-block btn-primary" debounceClick
                        (debounceClick)="activate()" [disabled]="loading || activateForm.invalid">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"
                            *ngIf="loading"></span>
                        {{ buttonText }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="row justify-content-center mt-4">
    <div class="col text-center">
        <span>Copyright © {{date | date: 'yyyy'}} Nexion. </span>
        <span>Privacy | Terms of use </span>
    </div>
</div>
